var exports = {
  "k": "xcc377c0b--c9cfbe--container",
};

module.exports = exports;
